export const generateLocaleStyle = (locale: Locale) => {
    const { rtl, fonts } = locale;

    const {
        lineHeightRatio,
        primaryFontRatio,
        primaryFont,
        secondaryFont,
        secondaryFontRatio,
        titleBoldValue,
    } = fonts ?? {};

    const styles = {
        direction: (rtl ? "rtl" : "ltr") as "rtl" | "ltr",
        fontFamily: primaryFont || "inherit",
        textAlign: (rtl ? "right" : "left") as "right" | "left",
        "--lineHeightRatio": lineHeightRatio || 1,
        "--secondaryFont": secondaryFont || "inherit",
        "--secondaryFontRatio": secondaryFontRatio || 1,
        "--primaryFont": primaryFont || "inherit",
        "--primaryFontRatio": primaryFontRatio || 1,
        "--titleBoldValue": titleBoldValue || "normal",
    };

    // Apply styles globally to html root to ensure they are accessible in #modal-root and other elements outside the tab
    const root = document.documentElement;
    Object.entries(styles).forEach(([key, value]) => {
        if (key.startsWith("--")) {
            root.style.setProperty(key, String(value));
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            root.style[key as any] = String(value);
        }
    });

    return styles;
};
